const removeTextFollowedByColon = function (text) {
    // the node can start with text followed by "::"; if it does, then it's instructional,
    // and shouldn't be included
    if (!text) return text;
    const re = new RegExp('\\\\', 'g'); // back slash validate
    let val = text;
    if (val && val.indexOf('::') > -1) {
        val = val.split('::')[1].replace(/^\s+/g, '');
    }
    val = val
        .replace(/&nbsp;/g, ' ')
        .replace(re, '');
    return val;
};
export default removeTextFollowedByColon;
